/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ series: NonNullable<unknown> }} Invoice_Misa_Template_SeriesInputs */

const vi_invoice_misa_template_series = /** @type {(inputs: Invoice_Misa_Template_SeriesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ký hiệu ${i?.series}`)
};

/**

* @param {Invoice_Misa_Template_SeriesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_series = /** @type {((inputs: Invoice_Misa_Template_SeriesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_SeriesInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_series(inputs)
});